import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import api from '~/services/api';

import SimpleSelect from './Simple';
import { LoadingContainer } from './styles';

function Fences({ ...props }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getDrivers() {
    setLoading(true);

    try {
      const { data } = await api.fetchDriver();
      setOptions(data);
      setLoading(false);
    } catch (erro) {
      setLoading(false);
      toast.error(
        'Erro ao consultar os motoristas! Tente novamente mais tarde.'
      );
    }
  }

  useEffect(() => {
    getDrivers();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingContainer {...props}>Loading</LoadingContainer>
      ) : (
        <SimpleSelect
          getOptionValue={({ id }) => id}
          getOptionLabel={({ name }) => name}
          emptyMessage="Nenhum registro encontrado"
          options={options}
          placeholder="Selecione o motorista"
          {...props}
        />
      )}
    </>
  );
}

export default Fences;
